import React from 'react';
import GridContainerImported from '@cdm/ccl-seo/GridContainer';
import './GridContainer.scss';

const GridContainer = ( props ) => (
    <GridContainerImported {...props} />
)
export default GridContainer;
